import GraphqlClient from './GraphqlClients';
import gql from 'graphql-tag';

export const getParsedQuery = gql`
  query ParsedDocument($filter: parser_DocumentsFilter) {
    document: parser_documents(filter: $filter) {
      link
    }
  }
`;

export const getScrapedQuery = gql`
  query ScrapedDocument($id: String!) {
    document: scp_document(id: $id) {
      requiresTransformation
      relatedDocumentId
      link
    }
  }
`;

export const getDocumentParserVersionQuery = gql`
  query DocumentParserVersion($id: String!) {
    documentParserVersion: parser_documentParserVersion(id: $id) {
      id
      majorVersion
      minorVersion
      patchVersion
      processedVersion
      latestVersion
      country
      documentType
      infoProvider
      formatType
    }
  }
`;

const DocumentService = async () => {
  const gqlClient = GraphqlClient();

  const reparseScraperMutation = gql`
    mutation Reparse($documentIds: [String!]) {
      operation: scp_resendToParser(documentIds: $documentIds) {
        documents {
          id
          status
        }
      }
    }
  `;

  const reparseParserMutation = gql`
    mutation Reparse($scrapedDocumentIds: [String!]) {
      operation: parser_reparse(scrapedDocumentIds: $scrapedDocumentIds) {
        documents {
          id
          status
        }
      }
    }
  `;

  const reparseApiMutation = gql`
    mutation Reparse($paymentIds: [String!]) {
      operation: api_reparsePayments(paymentIds: $paymentIds) {
        documents {
          id
          status
        }
      }
    }
  `;

  const refocusMutation = gql`
    mutation CustomRefocus($documentIds: [String!], $focusOptions: api_FocusOptionsAttributes!) {
      operation: api_customRefocusPayments(documentIds: $documentIds, focusOptions: $focusOptions) {
        documents {
          id
          status
        }
      }
    }
  `;

  const setDocumentStatusMutation = gql`
    mutation SetDocumentStatus($scrapedDocumentIds: [String!]!, $processStatus: String!) {
      operation: scp_setDocumentStatus(
        scrapedDocumentIds: $scrapedDocumentIds
        processStatus: $processStatus
      ) {
        documents {
          id
          status
        }
      }
    }
  `;

  return {
    getParsedDocuments: (ids) => {
      return gqlClient
        .query({
          query: getParsedQuery,
          variables: { filter: { ids: ids } }
        })
        .then((data) => data.data.document)
        .catch((error) => {
          console.error(error);
          return null;
        });
    },
    getDocumentParserVersion: (id) => {
      return gqlClient
        .query({
          fetchPolicy: 'network-only',
          query: getDocumentParserVersionQuery,
          variables: { id }
        })
        .then((data) => data.data.documentParserVersion)
        .catch(() => null);
    },
    getScrapedDocument: (id) => {
      return gqlClient
        .query({
          query: getScrapedQuery,
          variables: { id: id }
        })
        .then((data) => data.data.document)
        .catch((error) => {
          console.error(error);
          return null;
        });
    },
    reparseScraper: (documentIds) => {
      return gqlClient
        .mutate({
          mutation: reparseScraperMutation,
          variables: { documentIds }
        })
        .then((data) => data.data.operation.documents)
        .catch(() => null);
    },
    reparseParser: (scrapedDocumentIds) => {
      return gqlClient
        .mutate({
          mutation: reparseParserMutation,
          variables: { scrapedDocumentIds }
        })
        .then((data) => data.data.operation.documents)
        .catch((error) => {
          throw error;
        });
    },
    reparseApi: (paymentIds) => {
      return gqlClient
        .mutate({
          mutation: reparseApiMutation,
          variables: { paymentIds }
        })
        .then((data) => data.data.operation.documents)
        .catch((error) => {
          throw error;
        });
    },
    refocus: (documentIds, focusOptions) => {
      return gqlClient
        .mutate({
          mutation: refocusMutation,
          variables: { documentIds, focusOptions }
        })
        .then((data) => data.data.operation.documents)
        .catch((error) => {
          throw error;
        });
    },
    setDocumentStatus: (scrapedDocumentIds, processStatus) => {
      return gqlClient
        .mutate({
          mutation: setDocumentStatusMutation,
          variables: { scrapedDocumentIds, processStatus }
        })
        .then((data) => data.data.operation.documents)
        .catch((error) => {
          throw error;
        });
    }
  };
};

export default DocumentService;
